import { render, staticRenderFns } from "./ProgramTDC.vue?vue&type=template&id=7c49752c"
import script from "./ProgramTDC.vue?vue&type=script&lang=js"
export * from "./ProgramTDC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports